import React, { useContext } from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import { AuthContext } from "../context/auth";

export default function AuthRoute({ component: Component, ...rest }) {
	const { user } = useContext(AuthContext);

	return user ? <Navigate to='/' /> : <Component />;
}
